import { useEffect, useState } from "react";
import rotaService from "../../../services/RotaService";
import { Button, Modal } from "react-bootstrap";
import { faDoorClosed } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  ButtonSelecionar, JTable, JTBody, JTHead } from "../../../components/Components";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { addListaUFPercurso, removeListaUFPercursoTodos } from "../../../features/manifestoSlice";
import { getUuidV4 } from "../../../utils/utils";

interface RotaModalProps {
    show: boolean;
    onHide: () => void;
    ufini: string;
    uffim: string;

}

interface PercursoInterface {
    uf: string;
}

interface RotaInterface {
    id: string;
    descricao: string;
    ufini: string;
    uffim: string;
    percurso: PercursoInterface[]
}


const RotaModal: React.FC<RotaModalProps> = ({ show, onHide, ufini, uffim }) => {

    const [rotas, setRotas] = useState<RotaInterface[]>([])
    const selectUfPercurso = useSelector((state: RootState) => state.manifesto.selectEstados);
    
    
    const dispatch = useDispatch();

    useEffect(() => {
        rotaService.getByUfIniAndUfFim(ufini, uffim).then(res => {
            setRotas(res);

        }).catch(err => console.error(err.response.data.message))

    }, [])

    const handleAdicionarPercursos = (id: string) => {
    
        dispatch(removeListaUFPercursoTodos());
        rotas.filter(item => item.id === id)[0].percurso.map(item => item.uf).forEach(item => {
            
               dispatch(addListaUFPercurso({
                id: getUuidV4(),
                estado_id: selectUfPercurso.find(estado => estado.uf === item)?.id ?? 0,
                uf: item
            }));
        })
        onHide();
        
    }

    return (<>
        <Modal show={show} onHide={onHide} size="lg" centered backdrop='static' >
            <Modal.Header closeButton>
                <Modal.Title className="h6">Lista de rotas</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <JTable>
                    <JTHead>
                        <tr>
                            <th>Descrição</th>
                            <th>Percursos</th>
                            <th className="text-center">#</th>
                            
                        </tr>
                    </JTHead>
                    <JTBody>

                        {rotas.length > 0 && rotas?.map((item: RotaInterface) => (
                        <tr>
                            <td>{item.descricao}</td>
                            <td>{item.percurso.map(item => item.uf).join(' -> ')}</td>
                            <td className="text-center">
                                <ButtonSelecionar onClick={() => handleAdicionarPercursos(item.id)} />
                            </td>
                        </tr>
                    ))}
                    </JTBody>
                </JTable>
            </Modal.Body>

            <Modal.Footer>

                <Button variant="secondary" onClick={onHide}>
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    </>);
}

export default RotaModal;